module.exports = __webpack_public_path__ + "static/media/embedIcon.1ab6c64a.svg";